import { use } from 'react';

import type { ReactNode } from 'react';

/**
 * Suspends until the adapter's initial `list()` call has settled, preventing a
 * race where a user sends a message before the thread list has hydrated and the
 * active `remoteId` is still undefined.
 *
 * @param props - Barrier props.
 * @param props.listReady - Promise that resolves once list() settles.
 * @param props.children - Content to render once ready.
 */
export function ListReadyBarrier({ listReady, children }: { listReady: Promise<void>; children: ReactNode }) {
	use(listReady);
	return children;
}
